import React from 'react';
import { Icon, Grid, Popup, Button, Divider } from 'semantic-ui-react';

import AdPreview from '../../../components/common/AdPreview';
import AdMoreInfo from './AdMoreInfo';
import CanvasPreview from '../../../components/common/CanvasPreview';
import {
  renderDestinationUrls,
  renderLeadFormName,
  renderPopupContent,
  returnIframeForInstagramStory
} from '../../../utils/ad.common';
import './AdInfo.css';

const AdInfo = (props) => {
  const refreshPreview = (ad) => {
    props.refreshPreview(ad);
  };
  const eventSourceGroupName = props.eventSourceGroupName;

  const renderMobileAd = (preview) => (
    <AdPreview
      title="Mobile Ad Preview"
      maxWidthDiv={320}
      maxHeight={620}
      offsetVertical={900}
      iframe_url={preview.mobile_iframe_url}
    >
      {!(props.editId === ad.ad_id) ? (
        <div className="refresh-container">
          <a
            tabIndex={-1}
            role="button"
            className="refresh-button"
            onClick={() => refreshPreview(props.originalAd)}
          >
            <Icon size="large" name="refresh" />
          </a>
        </div>
      ) : null}
    </AdPreview>
  );
  const renderDesktopAd = (preview) => (
    <AdPreview
      title="Desktop Ad Preview"
      maxWidthDiv={720}
      maxHeight={762}
      offsetVertical={1500}
      iframe_url={preview.desktop_iframe_url}
    >
      {!(props.editId === ad.ad_id) ? (
        <div className="refresh-container">
          <a
            tabIndex={-1}
            role="button"
            className="refresh-button"
            onClick={() => refreshPreview(props.originalAd)}
          >
            <Icon size="large" name="refresh" />
          </a>
        </div>
      ) : null}
    </AdPreview>
  );

  const renderInstagramStoryAd = (instagramData) => {
    const iframeHtml = returnIframeForInstagramStory(instagramData);
    return (
      <AdPreview
        title="Instagram Story Ad"
        maxHeight={567}
        offsetVertical={1500}
        iframe_url={iframeHtml}
      />
    );
  };

  const renderUTMButton = (preview) => {
    if (preview.targetingSentenceLines) {
      return (
        <Popup
          wide="very"
          position="right center"
          trigger={
            <Button size="medium" color={props.isFormated ? 'blue' : 'red'}>
              Audience &amp; UTM
            </Button>
          }
          content={renderPopupContent(
            preview.targetingSentenceLines.targetingsentencelines
              .targetingsentencelines,
            preview.url_tags,
            eventSourceGroupName,
            preview.productSetName,
            preview.productCatalogName
          )}
          on="hover"
        />
      );
    }

    return null;
  };

  const determineTypeOfAdToRender = (ad) => {
    const { isInstagramAd, instagramData } = props;
    const isCollection = ad.ad_name.indexOf('Collection') !== -1;
    if (isCollection || ad.isCanvas) {
      return renderMobileAd(ad);
    } else if (isInstagramAd) {
      return renderInstagramStoryAd(instagramData);
    }
    return renderDesktopAd(ad);
  };

  const {
    ad,
    flipping,
    handleLinkClose,
    handleLinkOpen,
    copyLinkOpen,
    linkSource,
    copyAdIdOpen,
    handleAdIdClose,
    handleAdIdHover,
    handleAdIdClick,
    adIdText
  } = props;
  const isHold = ad && ad.adQc && ad.adQc.on_hold;
  let adStatus = false;

  if (ad && ad.ad_status === 'ACTIVE') {
    adStatus = ad.ad_status === 'ACTIVE' && !isHold;
  }

  return (
    <div className="ad-container">
      <div className="ad-header">
        <div>
          <h3>
            {adStatus ? (
              <i className="circle icon green" />
            ) : (
              <i className="circle icon black" />
            )}
            {adStatus ? 'Active' : 'Inactive'}
            {linkSource && (
                // eslint-disable-next-line react/jsx-indent
                <Popup
                  // ^^ this linting conlicts with prettier ^^
                  trigger={<Icon name="linkify" color="grey" />}
                  content="Copied to clipboard!"
                  on="click"
                  open={copyLinkOpen}
                  onClose={() => handleLinkClose(linkSource)}
                  onOpen={() => handleLinkOpen(linkSource)}
                  position="top right"
                />
              ) && (
                <span
                  role="button"
                  onClick={() => handleAdIdClick(linkSource)}
                  tabIndex={0}
                  style={{ outline: 'none' }}
                >
                  <Popup
                    trigger={
                      <Icon
                        className="preview-accordion-share-link"
                        name="file alternate outline"
                        color="grey"
                      />
                    }
                    on="hover"
                    content={adIdText}
                    open={copyAdIdOpen}
                    onClose={() => handleAdIdClose(linkSource)}
                    onOpen={() => handleAdIdHover(linkSource)}
                    position="top left"
                  />
                </span>
              )}
          </h3>
          Name: <strong>{ad.ad_name}</strong>
        </div>
        {renderDestinationUrls(ad.destination_url)}
        {renderLeadFormName(ad.lead_form_name)}
        <CanvasPreview
          canvasName={ad.canvas_name}
          destinationUrl={ad.destinationUrl}
          productSetName={ad.productSetName}
        />
        <Divider hidden />
        <Grid>
          <Grid.Row>
            <Grid.Column width={8}>
              {renderUTMButton(ad)}
              <div>
                Start Date: <strong>{ad.start_time}</strong>
              </div>
              <div>
                End Date: <strong>{ad.end_time}</strong>
              </div>
            </Grid.Column>
          </Grid.Row>
        </Grid>
      </div>
      <Divider hidden />
      {determineTypeOfAdToRender(ad)}
      {flipping ? null : <AdMoreInfo {...props} />}
    </div>
  );
};

export default AdInfo;



// WEBPACK FOOTER //
// ./src/screens/Flipper/ParentSection/AdInfo.js